/* global google */

import * as helpers from './interactive-map/map-helpers.js';

const MAP_STYLE = [
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#ffffff' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#d9eaf3' }],
  },
];

const DEFAULT_CENTER = {
  lat: 46.8139,
  lng: -71.208,
};
const DEFAULT_ZOOM = 10;

const CUSTOM_MARKER_ICON = {
  url: '/wp-content/themes/pcnphysio.com/assets/images/svgs/marker.svg',
  scaledSize: new google.maps.Size(40, 40),
  anchor: new google.maps.Point(20, 40),
};

document.addEventListener('DOMContentLoaded', () => {
  const mapEl = document.getElementById('clinics-map');
  if (!mapEl) return;

  if (typeof google === 'undefined') {
    return;
  }

  let map = null;
  let googleMarkers = [];
  const infoWindow = new google.maps.InfoWindow();

  function clearMarkers() {
    googleMarkers.forEach((marker) => marker.setMap(null));
    googleMarkers = [];
  }

  function initMap() {
    if (map) {
      return;
    }

    map = new google.maps.Map(mapEl, {
      zoom: DEFAULT_ZOOM,
      center: DEFAULT_CENTER,
      styles: MAP_STYLE,
    });
  }

  function addMarkers(markers) {
    const validMarkers = Array.isArray(markers) ? markers : [];

    initMap();

    if (!validMarkers.length) {
      return;
    }

    validMarkers.forEach((markerData) => {
      const gMarker = new google.maps.Marker({
        map,
        position: {
          lat: markerData.latitude,
          lng: markerData.longitude,
        },
        icon: markerData.icon || CUSTOM_MARKER_ICON,
      });

      if (markerData.popup) {
        gMarker.addListener('click', () => {
          infoWindow.setContent(markerData.popup);
          infoWindow.open(map, gMarker);
        });
      }

      googleMarkers.push(gMarker);
    });
  }

  if (window?.initialFindstrResults?.hits) {
    const markers = helpers.convertFindstrHitsToMarkers(
      window.initialFindstrResults.hits
    );
    addMarkers(markers);
  } else {
    initMap();
  }

  function attachFindstrHook() {
    const findstr = window.findstr;
    if (!findstr?.hooks?.addAction) {
      return false;
    }

    // Sync markers whenever Findstr results change, including initial load
    findstr.hooks.addAction('afterSearchResults', 'clinics-map', (results) => {
      clearMarkers();
      const markers = helpers.convertFindstrHitsToMarkers(results?.hits);
      addMarkers(markers);
    });

    // Also listen for Findstr initialization to ensure we capture filtered results on page load
    if (findstr.hooks?.addFilter) {
      findstr.hooks.addFilter(
        'findstrInitialized',
        'clinics-map',
        (initialized) => {
          // When Findstr is initialized with URL params, re-sync the map
          const currentResults = findstr.currentResults || findstr.results;
          if (currentResults?.hits) {
            clearMarkers();
            const markers = helpers.convertFindstrHitsToMarkers(
              currentResults.hits
            );
            addMarkers(markers);
          }
          return initialized;
        }
      );
    }

    return true;
  }

  if (!attachFindstrHook()) {
    let attempts = 0;
    const maxAttempts = 50;
    const findstrInterval = setInterval(() => {
      attempts += 1;
      if (attachFindstrHook() || attempts >= maxAttempts) {
        clearInterval(findstrInterval);
      }
    }, 100);
  }
});
